import {
    AdminDocumentResponseData,
    AdminPaymentResponseData,
    AdminProjectInfoResponseData,
    AdminProjectNoteResponseData,
    AvailableScopeResponseData,
    BillingTableResponseData,
    CancelPaymentRequest,
    CancelTaxInvoiceRequest,
    ClientListResponseData,
    ConfirmClientRequest,
    ConfirmProjectRequestRequest,
    ConfirmReportRequest,
    CreateAdminTaxInvoiceRequest,
    CreateContractRequest,
    CreateDocumentRequest,
    CreateModifyTaxInvoiceRequest,
    CreateProjectRequest, CreateRegularTaxInvoiceRequest,
    CreateWorkerRequestByAdminRequest,
    ExtendContractRequest,
    GetAdminClientInfoResponseData,
    GetAdminClientTableResponseData,
    GetAdminContractDashInfoResponseData,
    GetAdminContractInfoResponse,
    GetAdminContractResponseData,
    GetAdminContractTableResponseData,
    GetAdminEmailInfoResponseData,
    GetAdminInfoResponseData,
    GetAdminProjectDashInfoResponseData,
    GetAdminProjectRequestResponseData,
    GetAdminProjectRequestTableResponseData,
    GetAdminProjectTableResponseData,
    GetAdminRequestTableResponseData,
    GetClientsResponseData,
    GetConfirmResponseData,
    GetGraphResponseData,
    GetPaidPaymentResponseData, GetRegularTaxInvoiceResponseData, GetRegularTaxInvoiceTableResponseData,
    GetReportTableResponseData,
    GetTaxInvoiceInfoResponseData,
    GetTaxInvoiceTableResponseData,
    IssueTaxInvoiceRequest,
    LicenseFileResponseData,
    UpdateAdminEmailRequest,
    UpdateAdminProjectNoteRequest,
    UpdateAdminProjectRequest,
    UpdateChatRequest,
    UpdateClientRequest,
    UpdateContractRequest,
    UpdateDocumentRequest,
    UpdatePushSettingsRequest, UpdateRegularTaxInvoiceRequest,
    UpdateScopeRequest,
    UpdateTaxInvoiceRequest,
    UpdateTermRequest,
    WorkerRequestResponseData,
    WorkerRequestTableResponseData
} from "../types/admin";
import {api} from "./base";
import {ApiResponse, PageResponse} from "../types/response";
import {handleApiError} from "./util";
import {RequestStatus, RequestTarget, RequestType, WorkerRequestSort} from "../types/request";
import {ProjectRequestSort, ProjectSort, ProjectStatus, ProjectTarget} from "../types/project";
import {
    ClientSort,
    ClientStatus,
    ClientTarget,
    ContractStatus,
    InvoiceSort,
    InvoiceStatus,
    PaymentSort, PaymentTarget, RegularInvoiceSort
} from "../types/contract";
import {DocumentSort, DocumentTarget, DocumentType, ReportStatus, ReportTarget} from "../types/document";
import {DocumentTableResponseData} from "../types/client";

export const adminProjectInfoTableAPI = async (page: number): Promise<PageResponse<GetAdminProjectDashInfoResponseData[]>> => { //어드민 메인 대시보드 프로젝트 통계 테이블 조회 API 호출
    try {
        const response = await api.get<ApiResponse<PageResponse<GetAdminProjectDashInfoResponseData[]>>>('/project/admin/main?page=' + (page - 1));
        if (!response.data.success) {
            throw new Error(response.data.data.message);
        }
        return response.data.data;
    } catch (error) {
        handleApiError(error, '오류가 발생했습니다');
        throw error;
    }
}

export const adminContractInfoTableAPI = async (page: number): Promise<PageResponse<GetAdminContractDashInfoResponseData[]>> => { //어드민 계약 테이블 조회 API 호출
    try {
        const response = await api.get<ApiResponse<PageResponse<GetAdminContractDashInfoResponseData[]>>>('/contract/admin/main?page=' + (page - 1));
        if (!response.data.success) {
            throw new Error(response.data.data.message);
        }
        return response.data.data;
    } catch (error) {
        handleApiError(error, '오류가 발생했습니다');
        throw error;
    }
}

//어드민 메인 대시보드 요청 테이블 조회 API 호출
export const adminRequestTableAPI = async (params: {
    page: number,
    type?: RequestType[],
    create?: string,
    status?: RequestStatus[]
}): Promise<PageResponse<GetAdminRequestTableResponseData[]>> => {
    const searchParams = new URLSearchParams({
        size: "4",
        page: params.page.toString(),
        type: params.type?.join(',') || '가입,프로젝트,작업자',
        create: params.create || 'ALL',
        status: params.status?.join(',') || '대기,승인,반려,추가견적'
    });
    try {
        const response = await api.get<ApiResponse<PageResponse<GetAdminRequestTableResponseData[]>>>(`/request/admin?${searchParams}`);
        if (!response.data.success) {
            throw new Error(response.data.data.message);
        }
        return response.data.data;
    } catch (error) {
        handleApiError(error, '오류가 발생했습니다');
        throw error;
    }
}

export const adminClientGraphAPI = async (year: number): Promise<GetGraphResponseData[]> => { //계약 그래프 조회 API 호출
    try {
        const response = await api.get<ApiResponse<GetGraphResponseData[]>>('/contract/admin/graph?year=' + year);
        if (!response.data.success) {
            throw new Error(response.data.data.message);
        }
        return response.data.data;
    } catch (error) {
        handleApiError(error, '오류가 발생했습니다');
        throw error;
    }
}

export const adminProjectTableAPI = async (params: { //어드민 프로젝트 테이블 조회 API 호출
    page: number,
    sort?: ProjectSort,
    target?: ProjectTarget,
    search?: string,
    status?: ProjectStatus[],
    create?: string,
    start?: string,
    end?: string
}): Promise<PageResponse<GetAdminProjectTableResponseData[]>> => {
    const searchParams = new URLSearchParams({
        page: params.page.toString(),
        sort: params.sort || ProjectSort.COMPANY_ASC,
        target: params.target || ProjectTarget.ALL,
        search: params.search || '',
        status: params.status?.join(',') || '예정,진행중,완료',
        create: params.create || 'ALL',
        start: params.start || 'ALL',
        end: params.end || 'ALL',
    });
    try {
        const response = await api.get<ApiResponse<PageResponse<GetAdminProjectTableResponseData[]>>>(`/project/admin/table?${searchParams}`);
        if (!response.data.success) {
            throw new Error(response.data.data.message);
        }
        return response.data.data;
    } catch (error) {
        handleApiError(error, '오류가 발생했습니다');
        throw error;
    }
}

export const adminProjectInfoAPI = async (projectId: number): Promise<AdminProjectInfoResponseData> => { //어드민 단일 프로젝트 조회 API 호출
    try {
        const response = await api.get<ApiResponse<AdminProjectInfoResponseData>>('/project/admin/info?projectId=' + (projectId));
        if (!response.data.success) {
            throw new Error(response.data.data.message);
        }
        return response.data.data;
    } catch (error) {
        handleApiError(error, '오류가 발생했습니다.');
        throw error;
    }
}

export const adminProjectSampleAPI = async (projectId: number): Promise<Blob> => { //어드민 단일 프로젝트 샘플 데이터 조회 API 호출
    try {
        const response = await api.get(`/project/admin/sample?projectId=${projectId}`, {responseType: 'blob'});
        return response.data;
    } catch (error) {
        handleApiError(error, '오류가 발생했습니다.');
        throw error;
    }
}

export const adminProjectNoteAPI = async (projectId: number): Promise<AdminProjectNoteResponseData> => { //어드민 단일 프로젝트 특이사항 조회 API 호출
    try {
        const response = await api.get<ApiResponse<AdminProjectNoteResponseData>>('/project/admin/note?projectId=' + (projectId));
        if (!response.data.success) {
            throw new Error(response.data.data.message);
        }
        return response.data.data;
    } catch (error) {
        handleApiError(error, '오류가 발생했습니다.');
        throw error;
    }
}

export const adminProjectNoteImageAPI = async (projectId: number): Promise<Blob> => { //어드민 단일 프로젝트 특이사항 샘플 데이터 조회 API 호출
    try {
        const response = await api.get(`/project/admin/note-image?projectId=${projectId}`, {responseType: 'blob'});
        return response.data;
    } catch (error) {
        handleApiError(error, '오류가 발생했습니다.');
        throw error;
    }
}

export const adminProjectListAPI = async (): Promise<number[]> => { //어드민 프로젝트 식별자 목록 조회 API 호출
    try {
        const response = await api.get<ApiResponse<number[]>>('/project/admin/project-id');
        if (!response.data.success) {
            throw new Error(response.data.data.message);
        }
        return response.data.data;
    } catch (error) {
        handleApiError(error, '오류가 발생했습니다.');
        throw error;
    }
}
export const projectRequestSampleAPI = async (projectRequestId: number): Promise<Blob> => { //어드민 프로젝트 추가 요청 샘플 데이터 조회 API 호출
    try {
        const response = await api.get(`/projectRequest/admin/sample?projectRequestId=${projectRequestId}`, {responseType: 'blob'});
        return response.data;
    } catch (error) {
        handleApiError(error, '오류가 발생했습니다.');
        throw error;
    }
}


export const adminProjectRequestListAPI = async (): Promise<number[]> => { //어드민 프로젝트 추가 요청 식별자 목록 조회 API 호출
    try {
        const response = await api.get<ApiResponse<number[]>>('/projectRequest/admin/project-request-id');
        if (!response.data.success) {
            throw new Error(response.data.data.message);
        }
        return response.data.data;
    } catch (error) {
        handleApiError(error, '오류가 발생했습니다.');
        throw error;
    }
}

export const updateAdminProjectAPI = async (data: UpdateAdminProjectRequest, file: File | null) => { //어드민 프로젝트 단일 수정 API 호출
    try {
        const formData = new FormData();
        formData.append('request', new Blob([JSON.stringify(data)], {type: 'application/json'}));
        if (file) {
            formData.append('file', file);
        }
        const response = await api.patch(`/project/admin/info`, formData, {headers: {'Content-Type': 'multipart/form-data'}});
        if (!response.data.success) {
            throw new Error(response.data.data.message);
        }
        return response.data.data;
    } catch (error) {
        handleApiError(error, '오류가 발생했습니다.');
        throw error;
    }
}

export const updateAdminProjectNoteAPI = async (data: UpdateAdminProjectNoteRequest, file: File | null) => { //어드민 단일 프로젝트 특이사항 수정 API 호출
    try {
        const formData = new FormData();
        formData.append('request', new Blob([JSON.stringify(data)], {type: 'application/json'}));
        if (file) {
            formData.append('file', file);
        }
        const response = await api.patch(`/project/admin/note`, formData, {headers: {'Content-Type': 'multipart/form-data'}});
        if (!response.data.success) {
            throw new Error(response.data.data.message);
        }
        return response.data.data;
    } catch (error) {
        handleApiError(error, '오류가 발생했습니다.');
        throw error;
    }
}

export const adminProjectWorkerAPI = async (params: { projectId: number, workerAmount: number }) => { //프로젝트 할당 작업자 수 수정 API 호출
    const searchParams = new URLSearchParams({
        projectId: params.projectId.toString(),
        workerAmount: params.workerAmount.toString()
    });
    try {
        const response = await api.patch(`/project/admin/worker-amount?${searchParams}`);
        if (!response.data.success) {
            throw new Error(response.data.data.message);
        }
        return response.data.data;
    } catch (error) {
        handleApiError(error, '오류가 발생했습니다');
        throw error;
    }
}

export const adminClientDeleteAPI = async (clientIds: Set<number>) => { //클라이언트 삭제 API 호출
    try {
        const clientIdsArray = Array.from(clientIds);
        const response = await api.delete(`/client/admin?clientIds=${clientIdsArray.join(',')}`);
        if (!response.data.success) {
            throw new Error(response.data.data.message);
        }
        return response.data.data;
    } catch (error) {
        handleApiError(error, '오류가 발생했습니다');
        throw error;
    }
}

export const adminProjectRequestTableAPI = async (params: { //어드민 프로젝트 추가 요청 테이블 조회 API 호출
    page: number,
    sort?: ProjectRequestSort,
    target?: RequestTarget,
    search?: string,
    status?: ProjectStatus[],
    create?: string,
    start?: string,
    end?: string
}): Promise<PageResponse<GetAdminProjectRequestTableResponseData[]>> => {
    const searchParams = new URLSearchParams({
        page: params.page.toString(),
        sort: params.sort || ProjectRequestSort.COMPANY_ASC,
        target: params.target || RequestTarget.ALL,
        search: params.search || '',
        status: params.status?.join(',') || '예정,진행중,완료',
        create: params.create || 'ALL',
        start: params.start || 'ALL',
        end: params.end || 'ALL',
    });
    try {
        const response = await api.get<ApiResponse<PageResponse<GetAdminProjectRequestTableResponseData[]>>>(`/projectRequest/admin/table?${searchParams}`);
        if (!response.data.success) {
            throw new Error(response.data.data.message);
        }
        return response.data.data;
    } catch (error) {
        handleApiError(error, '오류가 발생했습니다');
        throw error;
    }
}

export const adminProjectRequestAPI = async (requestId: number): Promise<GetAdminProjectRequestResponseData> => { //어드민 프로젝트 추가 요청 단일 조회 API 호출
    try {
        const response = await api.get<ApiResponse<GetAdminProjectRequestResponseData>>('/projectRequest/admin?requestId=' + (requestId));
        if (!response.data.success) {
            throw new Error(response.data.data.message);
        }
        return response.data.data;
    } catch (error) {
        handleApiError(error, '오류가 발생했습니다.');
        throw error;
    }
}

export const confirmProjectRequestAPI = async (data: ConfirmProjectRequestRequest) => { //어드민 프로젝트 추가 요청 처리 API 호출
    try {
        const response = await api.post(`/projectRequest/admin/confirm`, data);
        if (!response.data.success) {
            throw new Error(response.data.data.message);
        }
        return response.data.data;
    } catch (error) {
        handleApiError(error, '오류가 발생했습니다.');
        throw error;
    }
}

export const adminClientTableAPI = async (params: { //클라이언트 정보 테이블 조회 API 호출
    page: number,
    target?: ClientTarget,
    search?: string,
    sort?: ClientSort,
    clientStatus?: ClientStatus[],
    contractStatus?: ContractStatus[],
    start?: string,
    expire?: string
}): Promise<PageResponse<GetAdminClientTableResponseData[]>> => {
    const searchParams = new URLSearchParams({
        page: params.page.toString(),
        sort: params.sort || ClientSort.COMPANY_ASC,
        target: params.target || ClientTarget.ALL,
        search: params.search || '',
        clientStatus: params.clientStatus?.join(',') || '승인',
        contractStatus: params.contractStatus?.join(',') || '계약,만료',
        start: params.start || 'ALL',
        expire: params.expire || 'ALL'
    });
    try {
        const response = await api.get<ApiResponse<PageResponse<GetAdminClientTableResponseData[]>>>(`/client/admin/table?${searchParams}`);
        if (!response.data.success) {
            throw new Error(response.data.data.message);
        }
        return response.data.data;
    } catch (error) {
        handleApiError(error, '오류가 발생했습니다');
        throw error;
    }
}

export const clientsAPI = async (): Promise<GetClientsResponseData[]> => { //승인된 클라이언트 전체 조회 API 호출
    try {
        const response = await api.get<ApiResponse<GetClientsResponseData[]>>(`/client/admin/approved`);
        if (!response.data.success) {
            throw new Error(response.data.data.message);
        }
        return response.data.data;
    } catch (error) {
        handleApiError(error, '오류가 발생했습니다');
        throw error;
    }
}

export const contractableClientsAPI = async (): Promise<GetClientsResponseData[]> => { //계약 가능한 클라이언트 전체 조회 API 호출
    try {
        const response = await api.get<ApiResponse<GetClientsResponseData[]>>(`/client/admin/contractable`);
        if (!response.data.success) {
            throw new Error(response.data.data.message);
        }
        return response.data.data;
    } catch (error) {
        handleApiError(error, '오류가 발생했습니다');
        throw error;
    }
}

export const createContractAPI = async (request: CreateContractRequest) => { //계약 생성 API 호출
    try {
        console.log(request);
        const response = await api.post(`/contract/admin`, request);
        if (!response.data.success) {
            throw new Error(response.data.data.message);
        }
        return response.data.data;
    } catch (error) {
        handleApiError(error, '오류가 발생했습니다.');
        throw error;
    }
}

export const getClientInfoAPI = async (clientId: number): Promise<GetAdminClientInfoResponseData> => { //어드민의 클라이언트 정보 조회 API 호출
    try {
        const response = await api.get(`/client/admin/info?clientId=` + clientId);
        if (!response.data.success) {
            throw new Error(response.data.data.message);
        }
        return response.data.data;
    } catch (error) {
        handleApiError(error, '오류가 발생했습니다.');
        throw error;
    }
}

export const adminClientListAPI = async (): Promise<number[]> => { //클라이언트 식별자 목록 조회 API 호출
    try {
        const response = await api.get<ApiResponse<number[]>>('/client/admin/client-id');
        if (!response.data.success) {
            throw new Error(response.data.data.message);
        }
        return response.data.data;
    } catch (error) {
        handleApiError(error, '오류가 발생했습니다.');
        throw error;
    }
}

export const adminContractListAPI = async (): Promise<number[]> => { //계약 식별자 목록 조회 API 호출
    try {
        const response = await api.get<ApiResponse<number[]>>('/contract/admin/contract-id');
        if (!response.data.success) {
            throw new Error(response.data.data.message);
        }
        return response.data.data;
    } catch (error) {
        handleApiError(error, '오류가 발생했습니다.');
        throw error;
    }
}

export const resetClientPasswordAPI = async (clientId: number): Promise<void> => { //어드민의 클라이언트 PW 초기화 API 호출
    try {
        const response = await api.patch<ApiResponse<void>>('/client/admin/reset-pw?clientId=' + clientId);
        if (!response.data.success) {
            throw new Error(response.data.data.message);
        }
    } catch (error) {
        handleApiError(error, '오류가 발생했습니다.');
        throw error;
    }
}

export const confirmClientAPI = async (confirmClientRequest: ConfirmClientRequest): Promise<void> => { //클라이언트 계정 처리 API 호출
    try {
        const response = await api.patch(`/client/admin/confirm`, confirmClientRequest);
        if (!response.data.success) {
            throw new Error(response.data.data.message);
        }
        return response.data.data;
    } catch (error) {
        handleApiError(error, '오류가 발생했습니다.');
        throw error;
    }
}

export const updateClientAPI = async (updateClientByAdminRequest: UpdateClientRequest): Promise<void> => { //어드민의 클라이언트 이메일 수정 API 호출
    try {
        const response = await api.patch(`/client/admin`, updateClientByAdminRequest);
        if (!response.data.success) {
            throw new Error(response.data.data.message);
        }
        return response.data.data;
    } catch (error) {
        handleApiError(error, '오류가 발생했습니다.');
        throw error;
    }
}

export const getLicenseFileAPI = async (clientId: number): Promise<LicenseFileResponseData> => { //어드민의 클라이언트 사업자등록증 조회 API 호출
    try {
        const response = await api.get(`/client/admin/license?clientId=${clientId}`, {responseType: 'blob'});
        return {data: response.data, extension: response.headers["file-extension"]};
    } catch (error) {
        handleApiError(error, '오류가 발생했습니다.');
        throw error;
    }
};

export const extendContractAPI = async (request: ExtendContractRequest): Promise<void> => { //일 단위 계약 연장 API 호출
    try {
        const response = await api.patch(`/contract/admin/extend`, request);
        if (!response.data.success) {
            throw new Error(response.data.data.message);
        }
        return response.data.data;
    } catch (error) {
        handleApiError(error, '오류가 발생했습니다.');
        throw error;
    }
}

export const updateContractAPI = async (request: UpdateContractRequest): Promise<void> => { //계약 수정 API 호출
    try {
        const response = await api.patch(`/contract/admin`, request);
        if (!response.data.success) {
            throw new Error(response.data.data.message);
        }
        return response.data.data;
    } catch (error) {
        handleApiError(error, '오류가 발생했습니다.');
        throw error;
    }
}

export const adminDocumentTableAPI = async (params: { //어드민 문서 테이블 조회 API 호출
    page: number,
    sort?: DocumentSort,
    target?: DocumentTarget,
    search?: string,
    type?: DocumentType[],
    clientIds?: number[],
    create?: string
}): Promise<PageResponse<DocumentTableResponseData[]>> => {
    const searchParams = new URLSearchParams({
        page: params.page.toString(),
        sort: params.sort || DocumentSort.CREATE_DESC,
        target: params.target || DocumentTarget.ALL,
        search: params.search || '',
        type: params.type?.join(',') || '보고서,견적서,가공가이드라인',
        clientIds: params.clientIds?.join(',') || '',
        create: params.create || 'ALL'
    });
    try {
        const response = await api.get<ApiResponse<PageResponse<DocumentTableResponseData[]>>>(`/document/admin/table?${searchParams}`);
        if (!response.data.success) {
            throw new Error(response.data.data.message);
        }
        return response.data.data;
    } catch (error) {
        handleApiError(error, '오류가 발생했습니다');
        throw error;
    }
}

export const getClientListAPI = async (): Promise<ClientListResponseData[]> => { //클라이언트 전체 조회 API 호출
    try {
        const response = await api.get(`/client/admin/list`);
        if (!response.data.success) {
            throw new Error(response.data.data.message);
        }
        return response.data.data;
    } catch (error) {
        handleApiError(error, '오류가 발생했습니다.');
        throw error;
    }
}

export const getApprovedClientListAPI = async (): Promise<ClientListResponseData[]> => { //클라이언트 전체 조회 API 호출
    try {
        const response = await api.get(`/client/admin/approved`);
        if (!response.data.success) {
            throw new Error(response.data.data.message);
        }
        return response.data.data;
    } catch (error) {
        handleApiError(error, '오류가 발생했습니다.');
        throw error;
    }
}

export const getAdminDocumentAPI = async (documentId: number): Promise<AdminDocumentResponseData> => { //어드민 문서 단일 조회 API 호출
    try {
        const response = await api.get(`/document/admin?documentId=` + documentId);
        if (!response.data.success) {
            throw new Error(response.data.data.message);
        }
        return response.data.data;
    } catch (error) {
        handleApiError(error, '오류가 발생했습니다.');
        throw error;
    }
}

export const getAdminDocumentFileAPI = async (documentId: number): Promise<Blob> => { //어드민 문서 첨부파일 조회 API 호출
    try {
        const response = await api.get(`/document/admin/file?documentId=${documentId}`, {responseType: 'blob'});
        return response.data;
    } catch (error) {
        handleApiError(error, '오류가 발생했습니다.');
        throw error;
    }
};

export const getDocumentScopesAPI = async (documentId: number): Promise<string[]> => { //어드민 문서 접근 가능 클라이언트 회사명 조회 API 호출
    try {
        const response = await api.get(`/document/admin/scope?documentId=` + documentId);
        if (!response.data.success) {
            throw new Error(response.data.data.message);
        }
        return response.data.data;
    } catch (error) {
        handleApiError(error, '오류가 발생했습니다.');
        throw error;
    }
}

export const getDocumentAvailableScopesAPI = async (documentId: number): Promise<AvailableScopeResponseData[]> => { //어드민 문서 접근 가능 클라이언트 조회 API 호출
    try {
        const response = await api.get(`/document/admin/scope/available?documentId=` + documentId);
        if (!response.data.success) {
            throw new Error(response.data.data.message);
        }
        return response.data.data;
    } catch (error) {
        handleApiError(error, '오류가 발생했습니다.');
        throw error;
    }
}

export const updateScopesAPI = async (updateDocumentScopeRequest: UpdateScopeRequest) => { //어드민 문서 접근 가능 클라이언트 수정 API 호출
    try {
        const response = await api.patch(`/document/admin/scope`, updateDocumentScopeRequest);
        if (!response.data.success) {
            throw new Error(response.data.data.message);
        }
        return response.data.data;
    } catch (error) {
        handleApiError(error, '오류가 발생했습니다.');
        throw error;
    }
}

export const deleteDocumentsAPI = async (documentIds: Set<number>) => { //문서 삭제 API 호출
    try {
        const documentIdsArray = Array.from(documentIds);
        const response = await api.delete(`/document/admin?documentIds=${documentIdsArray.join(',')}`);
        if (!response.data.success) {
            throw new Error(response.data.data.message);
        }
        return response.data.data;
    } catch (error) {
        handleApiError(error, '오류가 발생했습니다.');
        throw error;
    }
}

export const updateDocumentAPI = async (updateDocumentRequest: UpdateDocumentRequest, file: File | null) => { //문서 수정 API 호출
    try {
        const formData = new FormData();
        formData.append('updateDocumentRequest', new Blob([JSON.stringify(updateDocumentRequest)], {type: 'application/json'}));
        if (file) {
            formData.append('file', file);
        }
        const response = await api.patch(`/document/admin`, formData, {headers: {'Content-Type': 'multipart/form-data'}});
        if (!response.data.success) {
            throw new Error(response.data.data.message);
        }
        return response.data.data;
    } catch (error) {
        handleApiError(error, '오류가 발생했습니다.');
        throw error;
    }
}

export const createDocumentAPI = async (createDocumentRequest: CreateDocumentRequest, file: File | null) => { //문서 생성 API 호출
    try {
        const formData = new FormData();
        formData.append('createDocumentRequest', new Blob([JSON.stringify(createDocumentRequest)], {type: 'application/json'}));
        if (file) {
            formData.append('file', file);
        }
        const response = await api.post(`/document/admin`, formData, {headers: {'Content-Type': 'multipart/form-data'}});
        if (!response.data.success) {
            throw new Error(response.data.data.message);
        }
        return response.data.data;
    } catch (error) {
        handleApiError(error, '오류가 발생했습니다.');
        throw error;
    }
}

export const adminReportTableAPI = async (params: { //자동 생성 보고서 테이블 API 호출
    page: number,
    sort?: DocumentSort,
    target?: ReportTarget,
    search?: string,
    status?: ReportStatus[],
    year?: string,
    month?: string
}): Promise<PageResponse<GetReportTableResponseData[]>> => {
    const searchParams = new URLSearchParams({
        page: params.page.toString(),
        sort: params.sort || DocumentSort.CREATE_DESC,
        target: params.target || ReportTarget.ALL,
        search: params.search || '',
        status: params.status?.join(',') || '대기,반려',
        year: params.year || 'ALL',
        month: params.month || 'ALL'
    });
    try {
        const response = await api.get<ApiResponse<PageResponse<GetReportTableResponseData[]>>>(`/document/admin/confirm/table?${searchParams}`);
        if (!response.data.success) {
            throw new Error(response.data.data.message);
        }
        return response.data.data;
    } catch (error) {
        handleApiError(error, '오류가 발생했습니다');
        throw error;
    }
}

export const confirmAPI = async (request: ConfirmReportRequest) => { //자동 생성 보고서 처리 API 호출
    try {
        const response = await api.patch(`/document/admin/confirm`, request);
        if (!response.data.success) {
            throw new Error(response.data.data.message);
        }
        return response.data.data;
    } catch (error) {
        handleApiError(error, '오류가 발생했습니다.');
        throw error;
    }
}

export const getConfirmAPI = async (reportId: number): Promise<GetConfirmResponseData> => { //자동 생성 보고서 단일 조회 API 호출
    try {
        const response = await api.get(`/document/admin/confirm?reportId=` + reportId);
        if (!response.data.success) {
            throw new Error(response.data.data.message);
        }
        return response.data.data;
    } catch (error) {
        handleApiError(error, '오류가 발생했습니다.');
        throw error;
    }
}

export const getFileAPI = async (reportId: number): Promise<Blob> => { //자동 생성 보고서 PDF 조회 API 호출
    try {
        const response = await api.get(`/document/admin/confirm/file?reportId=${reportId}`, {
            responseType: 'blob',
            headers: {'Accept': 'application/pdf'}
        });
        return new Blob([response.data], {type: 'application/pdf'});
    } catch (error) {
        handleApiError(error, '오류가 발생했습니다.');
        throw error;
    }
};

export const updateTermAPI = async (request: UpdateTermRequest) => { //최신 데이터 사업 규정 생성 API 호출
    try {
        const response = await api.post('/terms/term', request);
        if (!response.data.success) {
            throw new Error(response.data.data.message);
        }
        return response.data.data;
    } catch (error) {
        handleApiError(error, '오류가 발생했습니다.');
        throw error;
    }
}

export const updatePolicyAPI = async (request: UpdateTermRequest) => { //최신 개인정보 처리 규정 생성 API 호출
    try {
        const response = await api.post('/terms/policy', request);
        if (!response.data.success) {
            throw new Error(response.data.data.message);
        }
        return response.data.data;
    } catch (error) {
        handleApiError(error, '오류가 발생했습니다.');
        throw error;
    }
}

export const updateRegisterAPI = async (request: UpdateTermRequest) => { //최신 회원가입 규정 생성 API 호출
    try {
        const response = await api.post('/terms/register', request);
        if (!response.data.success) {
            throw new Error(response.data.data.message);
        }
        return response.data.data;
    } catch (error) {
        handleApiError(error, '오류가 발생했습니다.');
        throw error;
    }
}

export const getAdminInfoAPI = async (): Promise<GetAdminInfoResponseData> => { //어드민 정보 조회 API 호출
    try {
        const response = await api.get('/admin/info');
        if (!response.data.success) {
            throw new Error(response.data.data.message);
        }
        return response.data.data;
    } catch (error) {
        handleApiError(error, '오류가 발생했습니다.');
        throw error;
    }
}

export const updateChatAPI = async (request: UpdateChatRequest) => { //어드민 챗봇 첫 출력 문장 수정 API 호출
    try {
        const response = await api.patch('/admin/chat', request);
        if (!response.data.success) {
            throw new Error(response.data.data.message);
        }
        return response.data.data;
    } catch (error) {
        handleApiError(error, '오류가 발생했습니다.');
        throw error;
    }
}

export const getEmailInfoAPI = async (): Promise<GetAdminEmailInfoResponseData> => { //어드민 이메일 정보 조회 API 호출
    try {
        const response = await api.get('/admin/email');
        if (!response.data.success) {
            throw new Error(response.data.data.message);
        }
        return response.data.data;
    } catch (error) {
        handleApiError(error, '오류가 발생했습니다.');
        throw error;
    }
}

export const updatePushAPI = async (request: UpdatePushSettingsRequest) => { //어드민 푸시 설정 수정 API 호출
    try {
        const response = await api.patch('/admin/push', request);
        if (!response.data.success) {
            throw new Error(response.data.data.message);
        }
        return response.data.data;
    } catch (error) {
        handleApiError(error, '오류가 발생했습니다.');
        throw error;
    }
}

export const updatePasswordAPI = async (password: string) => { //어드민 비밀번호 수정 API 호출
    try {
        const response = await api.patch('/admin/password', {password: password});
        if (!response.data.success) {
            throw new Error(response.data.data.message);
        }
        return response.data.data;
    } catch (error) {
        handleApiError(error, '오류가 발생했습니다.');
        throw error;
    }
}

export const getChatBotAPI = async (): Promise<string> => { //챗봇 첫 출력 문장 조회 API 호출
    try {
        const response = await api.get('/admin/chat');
        if (!response.data.success) {
            throw new Error(response.data.data.message);
        }
        return response.data.data;
    } catch (error) {
        handleApiError(error, '오류가 발생했습니다.');
        throw error;
    }
}

export const updateAdminIdAPI = async (id: string) => { // 어드민 ID 수정 API 호출
    try {
        const response = await api.patch('/admin/id', {userName: id});
        if (!response.data.success) {
            throw new Error(response.data.data.message);
        }
        return response.data.data;
    } catch (error) {
        handleApiError(error, '오류가 발생했습니다.');
        throw error;
    }
}

export const testEmailAPI = async (request: UpdateAdminEmailRequest) => { //어드민 신규 이메일 테스트 API 호출
    try {
        const response = await api.post('/admin/email/test', request);
        if (!response.data.success) {
            throw new Error(response.data.data.message);
        }
        return response.data.data;
    } catch (error) {
        handleApiError(error, '오류가 발생했습니다.');
        throw error;
    }
}

export const verifyAdminEmailAPI = async (email: string, code: string) => { //어드민 이메일 코드 인증 API 호출
    try {
        const response = await api.get(`/admin/email/verify?email=${email}&code=${code}`);
        if (!response.data.success) {
            throw new Error(response.data.data.message);
        }
        return response.data.data;
    } catch (error) {
        handleApiError(error, '오류가 발생했습니다.');
        throw error;
    }
}

export const updateAdminEmailAPI = async (request: UpdateAdminEmailRequest) => { //어드민 이메일 수정 API 호출
    try {
        const response = await api.patch('/admin/email', request);
        if (!response.data.success) {
            throw new Error(response.data.data.message);
        }
        return response.data.data;
    } catch (error) {
        handleApiError(error, '오류가 발생했습니다.');
        throw error;
    }
}

export const adminWorkerRequestTableAPI = async (params: { //어드민 작업자 추가 요청 테이블 조회 API 호출
    page: number,
    sort?: WorkerRequestSort,
    companyName?: string,
    status?: RequestStatus[],
    create?: string,
    start?: string,
    confirm?: string,
    min?: number,
    max?: number
}): Promise<PageResponse<WorkerRequestTableResponseData[]>> => {
    const searchParams = new URLSearchParams({
        page: params.page.toString(),
        sort: params.sort || WorkerRequestSort.COMPANY_ASC,
        companyName: params.companyName || '',
        status: params.status?.join(',') || '대기,승인,반려,어드민',
        create: params.create || 'ALL',
        start: params.start || 'ALL',
        confirm: params.confirm || 'ALL',
        min: params.min?.toString() || '-100',
        max: params.max?.toString() || '100',
    });
    try {
        const response = await api.get<ApiResponse<PageResponse<WorkerRequestTableResponseData[]>>>(`/workerRequest/admin/table?${searchParams}`);
        if (!response.data.success) {
            throw new Error(response.data.data.message);
        }
        return response.data.data;
    } catch (error) {
        handleApiError(error, '오류가 발생했습니다');
        throw error;
    }
}

export const adminWorkerRequestAPI = async (workerRequestId: number): Promise<WorkerRequestResponseData> => { //어드민 작업자 추가 요청 단일 조회 API 호출
    try {
        const response = await api.get<ApiResponse<WorkerRequestResponseData>>(`/workerRequest/admin?workerRequestId=` + workerRequestId);
        if (!response.data.success) {
            throw new Error(response.data.data.message);
        }
        return response.data.data;
    } catch (error) {
        handleApiError(error, '오류가 발생했습니다');
        throw error;
    }
}

export const adminWorkerRequestListAPI = async (): Promise<number[]> => { //작업자 추가 요청 식별자 목록 조회 API 호출
    try {
        const response = await api.get<ApiResponse<number[]>>('/workerRequest/admin/worker-request-id');
        if (!response.data.success) {
            throw new Error(response.data.data.message);
        }
        return response.data.data;
    } catch (error) {
        handleApiError(error, '오류가 발생했습니다.');
        throw error;
    }
}

export const confirmWorkerRequestAPI = async (request: { //어드민 작업자 추가 요청 처리 API 호출
    workerRequestId: number;
    status: RequestStatus;
    rejectComment?: string;
    expireAt?: string;
    period?: number;
}) => {
    try {
        const response = await api.patch('/workerRequest/admin', request);
        if (!response.data.success) {
            throw new Error(response.data.data.message);
        }
        return response.data.data;
    } catch (error) {
        handleApiError(error, '오류가 발생했습니다.');
        throw error;
    }
}

export const adminBillingTableAPI = async (params: { //어드민 결제 테이블 조회 API 호출
    page: number,
    sort?: PaymentSort,
    search?: string,
    target?: string,
    min?: number,
    max?: number,
    paid?: string,
    isPaid?: boolean[]
}): Promise<PageResponse<BillingTableResponseData[]>> => {
    const searchParams = new URLSearchParams({
        page: params.page.toString(),
        sort: params.sort || PaymentSort.PAID_DESC,
        search: params.search || '',
        target: params.target || PaymentTarget.ALL,
        min: params.min?.toString() || "0",
        max: params.max?.toString() || "1000000000",
        paid: params.paid || 'ALL',
        isPaid: params.isPaid?.toString() || "true,false"
    });
    try {
        const response = await api.get<ApiResponse<PageResponse<BillingTableResponseData[]>>>(`/payment/admin/table?${searchParams}`);
        if (!response.data.success) {
            throw new Error(response.data.data.message);
        }
        return response.data.data;
    } catch (error) {
        handleApiError(error, '오류가 발생했습니다');
        throw error;
    }
}

export const adminPaymentGraphAPI = async (year: number): Promise<GetGraphResponseData[]> => { //어드민 결제 통계 그래프 조회 API 호출
    try {
        const response = await api.get<ApiResponse<GetGraphResponseData[]>>('/payment/admin/graph?year=' + year);
        if (!response.data.success) {
            throw new Error(response.data.data.message);
        }
        return response.data.data;
    } catch (error) {
        handleApiError(error, '오류가 발생했습니다');
        throw error;
    }
}

export const adminFirstClientAPI = async (): Promise<number> => { //첫 클라이언트 승인된 연도 조회 API 호출
    try {
        const response = await api.get<ApiResponse<number>>('/client/admin/first');
        if (!response.data.success) {
            throw new Error(response.data.data.message);
        }
        return response.data.data;
    } catch (error) {
        handleApiError(error, '오류가 발생했습니다');
        throw error;
    }
}

export const adminFirstPaymentAPI = async (): Promise<number> => { //전체 결제 중 첫 결제 연도 조회 API 호출
    try {
        const response = await api.get<ApiResponse<number>>('/payment/admin/first');
        if (!response.data.success) {
            throw new Error(response.data.data.message);
        }
        return response.data.data;
    } catch (error) {
        handleApiError(error, '오류가 발생했습니다');
        throw error;
    }
}

export const adminWorkerAmountAPI = async (projectId: number): Promise<number> => { //클라이언트의 현재 계약 중인 작업자 수 조회 API 호출
    try {
        const response = await api.get<ApiResponse<number>>('/client/admin/worker-amount?projectId=' + projectId);
        if (!response.data.success) {
            throw new Error(response.data.data.message);
        }
        return response.data.data;
    } catch (error) {
        handleApiError(error, '오류가 발생했습니다');
        throw error;
    }
}


export const getPaymentAPI = async (paymentId: number): Promise<AdminPaymentResponseData> => { //어드민 결제 단건 조회 API 호출
    try {
        const response = await api.get<ApiResponse<AdminPaymentResponseData>>('/payment/admin?paymentId=' + paymentId);
        if (!response.data.success) {
            throw new Error(response.data.data.message);
        }
        return response.data.data;
    } catch (error) {
        handleApiError(error, '오류가 발생했습니다');
        throw error;
    }
}

export const cancelPaymentAPI = async (cancelPaymentRequest: CancelPaymentRequest) => { //결제 취소 API 호출
    try {
        const response = await api.patch<ApiResponse<AdminPaymentResponseData>>('/payment/admin/cancel', cancelPaymentRequest);
        if (!response.data.success) {
            throw new Error(response.data.data.message);
        }
        return response.data.data;
    } catch (error) {
        handleApiError(error, '오류가 발생했습니다');
        throw error;
    }
}

export const adminContractTableAPI = async (params: { //계약 상세 테이블 조회 API 호출
    page: number,
    sort?: ClientSort,
    target?: string,
    search?: string,
    start?: string,
    expire?: string,
    contractStatus?: ContractStatus[]
}): Promise<PageResponse<GetAdminContractTableResponseData[]>> => {
    const searchParams = new URLSearchParams({
        page: params.page.toString(),
        sort: params.sort || ClientSort.START_DESC,
        start: params.start || 'ALL',
        expire: params.expire || 'ALL',
        contractStatus: params.contractStatus?.join(',') || '계약,만료'
    });
    try {
        const response = await api.get<ApiResponse<PageResponse<GetAdminContractTableResponseData[]>>>(`/contract/admin/table?${searchParams}`);
        if (!response.data.success) {
            throw new Error(response.data.data.message);
        }
        return response.data.data;
    } catch (error) {
        handleApiError(error, '오류가 발생했습니다');
        throw error;
    }
}

export const adminContractAPI = async (contractId: number): Promise<GetAdminContractResponseData> => { //계약 단일 조회 API 호출
    try {
        const response = await api.get<ApiResponse<GetAdminContractResponseData>>('/contract/admin?contractId=' + contractId);
        if (!response.data.success) {
            throw new Error(response.data.data.message);
        }
        return response.data.data;
    } catch (error) {
        handleApiError(error, '오류가 발생했습니다');
        throw error;
    }
}

export const deleteContractAPI = async (contractId: number): Promise<void> => { //계약 삭제 API 호출
    try {
        const response = await api.delete<ApiResponse<void>>('/contract/admin?contractId=' + contractId);
        if (!response.data.success) {
            throw new Error(response.data.data.message);
        }
        return response.data.data;
    } catch (error) {
        handleApiError(error, '오류가 발생했습니다');
        throw error;
    }
}

export const createWorkerRequestByAdminAPI = async (createWorkerRequestByAdminRequest: CreateWorkerRequestByAdminRequest): Promise<void> => { //어드민용 작업자 추가 요청 생성 API 호출
    try {
        const response = await api.post<ApiResponse<void>>('/request/admin/worker', createWorkerRequestByAdminRequest);
        if (!response.data.success) {
            throw new Error(response.data.data.message);
        }
        return response.data.data;
    } catch (error) {
        handleApiError(error, '오류가 발생했습니다');
        throw error;
    }
}

export const adminContractInfoAPI = async (clientId: number): Promise<GetAdminContractInfoResponse[]> => { //단일 클라이언트 계약 목록 조회 API 호출
    try {
        const response = await api.get<ApiResponse<GetAdminContractInfoResponse[]>>('/contract/admin/client?clientId=' + clientId);
        if (!response.data.success) {
            throw new Error(response.data.data.message);
        }
        return response.data.data;
    } catch (error) {
        handleApiError(error, '오류가 발생했습니다');
        throw error;
    }
}

export const adminDeleteWorkerRequestAPI = async (workerRequestId: number) => { //어드민 작업자 추가 요청 삭제 API 호출
    try {
        const response = await api.delete<ApiResponse<void>>('/workerRequest/admin?workerRequestId=' + workerRequestId);
        if (!response.data.success) {
            throw new Error(response.data.data.message);
        }
        return response.data.data;
    } catch (error) {
        handleApiError(error, '오류가 발생했습니다');
        throw error;
    }
}

export const adminCheckPaymentAPI = async (params: { clientId: number, startAt: string }): Promise<number> => {//어드민 조기 결제 개수 확인 API 호출
    try {
        const searchParams = new URLSearchParams({
            clientId: params.clientId.toString(),
            startAt: params.startAt
        });
        const response = await api.get<ApiResponse<number>>(`/payment/admin/check?${searchParams}`);
        if (!response.data.success) {
            throw new Error(response.data.data.message);
        }
        return response.data.data;
    } catch (error) {
        handleApiError(error, '오류가 발생했습니다');
        throw error;
    }
}

export const createProjectAPI = async (request: CreateProjectRequest, file: File | null) => { //프로젝트 생성 API 호출
    try {
        const formData = new FormData();
        formData.append('request', new Blob([JSON.stringify(request)], {type: 'application/json'}));
        if (file) {
            formData.append('file', file);
        }
        const response = await api.post(`/project/admin`, formData, {headers: {'Content-Type': 'multipart/form-data'}});
        if (!response.data.success) {
            throw new Error(response.data.data.message);
        }
        return response.data.data;
    } catch (error) {
        handleApiError(error, '오류가 발생했습니다.');
        throw error;
    }
}

export const adminTaxInvoiceTableAPI = async (params: { //어드민 세금계산서 테이블 조회 API 호출
    page: number,
    sort?: InvoiceSort,
    target?: string,
    search?: string,
    create?: string,
    issue?: string,
    min?: number,
    max?: number,
    status?: InvoiceStatus[]
}): Promise<PageResponse<GetTaxInvoiceTableResponseData[]>> => {
    const searchParams = new URLSearchParams({
        page: params.page.toString(),
        sort: params.sort || InvoiceSort.CREATE_DESC,
        target: params.target || '',
        search: params.search || '',
        create: params.create || 'ALL',
        issue: params.issue || 'ALL',
        min: params.min?.toString() || '0',
        max: params.max?.toString() || '1000000000',
        status: params.status?.join(',') || '임시저장,발행,전송전,전송성공,전송실패,발행취소'
    });
    try {
        const response = await api.get<ApiResponse<PageResponse<GetTaxInvoiceTableResponseData[]>>>(`/tax/admin/table?${searchParams}`);
        if (!response.data.success) {
            throw new Error(response.data.data.message);
        }
        return response.data.data;
    } catch (error) {
        handleApiError(error, '오류가 발생했습니다');
        throw error;
    }
}

export const updateTaxInvoiceAPI = async (request: UpdateTaxInvoiceRequest) => { //세금계산서 수정 API 호출
    try {
        const response = await api.patch(`/tax/admin`, request);
        if (!response.data.success) {
            throw new Error(response.data.data.message);
        }
        return response.data.data;
    } catch (error) {
        handleApiError(error, '오류가 발생했습니다.');
        throw error;
    }
}

export const deleteTaxInvoiceAPI = async (taxInvoiceId: number) => { //세금계산서 삭제 API 호출
    try {
        const response = await api.delete(`/tax/admin?taxInvoiceId=` + taxInvoiceId);
        if (!response.data.success) {
            throw new Error(response.data.data.message);
        }
        return response.data.data;
    } catch (error) {
        handleApiError(error, '오류가 발생했습니다.');
        throw error;
    }
}

export const issueTaxInvoiceAPI = async (request: IssueTaxInvoiceRequest) => { //임시 저장 세금계산서 발행 API 호출
    try {
        const response = await api.post(`/tax/admin/issue`, request);
        if (!response.data.success) {
            throw new Error(response.data.data.message);
        }
        return response.data.data;
    } catch (error) {
        handleApiError(error, '오류가 발생했습니다.');
        throw error;
    }
}

export const cancelTaxInvoiceAPI = async (request: CancelTaxInvoiceRequest) => { //세금계산서 수정 API 호출
    try {
        const response = await api.patch(`/tax/admin/cancel`, request);
        if (!response.data.success) {
            throw new Error(response.data.data.message);
        }
        return response.data.data;
    } catch (error) {
        handleApiError(error, '오류가 발생했습니다.');
        throw error;
    }
}

export const createModifyTaxInvoiceAPI = async (request: CreateModifyTaxInvoiceRequest) => { //수정 세금계산서 생성 API 호출
    try {
        const response = await api.post(`/tax/admin/modify`, request);
        if (!response.data.success) {
            throw new Error(response.data.data.message);
        }
        return response.data.data;
    } catch (error) {
        handleApiError(error, '오류가 발생했습니다.');
        throw error;
    }
}

export const getTaxInvoiceInfoAPI = async (taxInvoiceId: number): Promise<GetTaxInvoiceInfoResponseData> => { //세금계산서 단일 조회 API 호출
    try {
        const response = await api.get<ApiResponse<GetTaxInvoiceInfoResponseData>>('/tax/admin?taxInvoiceId=' + taxInvoiceId);
        if (!response.data.success) {
            throw new Error(response.data.data.message);
        }
        return response.data.data;
    } catch (error) {
        handleApiError(error, '오류가 발생했습니다.');
        throw error;
    }
}

export const createAdminTaxInvoiceAPI = async (request: CreateAdminTaxInvoiceRequest) => { //어드민 세금계산서 즉시발행 API 호출
    try {
        const response = await api.post(`/tax/admin`, request);
        if (!response.data.success) {
            throw new Error(response.data.data.message);
        }
        return response.data.data;
    } catch (error) {
        handleApiError(error, '오류가 발생했습니다.');
        throw error;
    }
}

export const getAdminPaidPaymentsAPI = async (): Promise<GetPaidPaymentResponseData[]> => { //결제된 결제 목록 조회 API 호출
    try {
        const response = await api.get<ApiResponse<GetPaidPaymentResponseData[]>>('/payment/admin/list');
        if (!response.data.success) {
            throw new Error(response.data.data.message);
        }
        return response.data.data;
    } catch (error) {
        handleApiError(error, '오류가 발생했습니다');
        throw error;
    }
}

export const adminRegularTaxInvoiceTableAPI = async (params: { //어드민 정기 세금계산서 발행 테이블 조회 API 호출
    page: number,
    sort?: RegularInvoiceSort,
    target?: string,
    search?: string,
    min?: number,
    max?: number
}): Promise<PageResponse<GetRegularTaxInvoiceTableResponseData[]>> => {
    const searchParams = new URLSearchParams({
        page: params.page.toString(),
        sort: params.sort || RegularInvoiceSort.COMPANY_ASC,
        target: params.target || '',
        search: params.search || '',
        min: params.min?.toString() || '0',
        max: params.max?.toString() || '1000000000'
    });
    try {
        const response = await api.get<ApiResponse<PageResponse<GetRegularTaxInvoiceTableResponseData[]>>>(`/tax/admin/regular/table?${searchParams}`);
        if (!response.data.success) {
            throw new Error(response.data.data.message);
        }
        return response.data.data;
    } catch (error) {
        handleApiError(error, '오류가 발생했습니다');
        throw error;
    }
}

export const createRegularAdminTaxInvoiceAPI = async (request: CreateRegularTaxInvoiceRequest) => { //어드민 세금계산서 정기발행 생성 API 호출
    try {
        const response = await api.post(`/tax/admin/regular`, request);
        if (!response.data.success) {
            throw new Error(response.data.data.message);
        }
        return response.data.data;
    } catch (error) {
        handleApiError(error, '오류가 발생했습니다.');
        throw error;
    }
}

export const getRegularTaxInvoiceInfoAPI = async (taxInvoiceId: number): Promise<GetRegularTaxInvoiceResponseData> => { //세금계산서 단일 조회 API 호출
    try {
        const response = await api.get<ApiResponse<GetRegularTaxInvoiceResponseData>>('/tax/admin/regular?taxInvoiceId=' + taxInvoiceId);
        if (!response.data.success) {
            throw new Error(response.data.data.message);
        }
        return response.data.data;
    } catch (error) {
        handleApiError(error, '오류가 발생했습니다.');
        throw error;
    }
}

export const updateRegularAdminTaxInvoiceAPI = async (request: UpdateRegularTaxInvoiceRequest) => { //어드민 세금계산서 정기발행 생성 API 호출
    try {
        const response = await api.patch(`/tax/admin/regular`, request);
        if (!response.data.success) {
            throw new Error(response.data.data.message);
        }
        return response.data.data;
    } catch (error) {
        handleApiError(error, '오류가 발생했습니다.');
        throw error;
    }
}

export const deleteRegularAdminTaxInvoiceAPI = async (regularTaxInvoiceId: number) => { //어드민 세금계산서 정기발행 생성 API 호출
    try {
        const response = await api.delete(`/tax/admin/regular?regularTaxInvoiceId=`+ regularTaxInvoiceId);
        if (!response.data.success) {
            throw new Error(response.data.data.message);
        }
        return response.data.data;
    } catch (error) {
        handleApiError(error, '오류가 발생했습니다.');
        throw error;
    }
}